import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    option: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      color: COLORS.gray.black,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
    },
    aspectIcon: {
      fontSize: theme.typography.pxToRem(20),
    },
    menuItem: {},
    gray: {
      color: COLORS.gray.gray50,
    },
  }),
  { name: 'BlockAspectRatio' }
);
